var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.650391 4.16663V5.83329H11.0222V4.16663H0.650391Z",
    fill: "#6F6969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6709 8.72375L7.84941 9.90227L12.7516 5.00005L11.5731 3.82154L6.6709 8.72375Z",
    fill: "#6F6969"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84961 0.0977783L6.6711 1.27629L11.5733 6.17851L12.7518 5L7.84961 0.0977783Z",
    fill: "#6F6969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2503aae4783e25504c341685b69defa8.svg";
export { ForwardRef as ReactComponent };